import { IconSize } from "@/src/components/icons/components/IconContainer";
import { InfoCircle } from "nvs-ds-icons/react/core";
import { Label4, Label8 } from "@/src/components/typography/components/Label";
import Tooltip from "@/src/components/Tooltip";
import TooltipPanel from "@/src/components/Tooltip/components/TooltipPanel";
import TooltipButton from "@/src/components/Tooltip/components/TooltipButton";
import { Body8 } from "@/src/components/typography/components/Body";

export const SOLEBOUND_TOOLTIP_LABEL =
  "Get more information on Solebound tokens";
export const SOLEBOUND_LABEL = "Solebound";
export const SOLEBOUND_COPY =
  "This Nike Virtual Creation is linked to your account and cannot be bought or sold.";

export function SoleboundFooter() {
  return (
    <div className="flex-grow flex gap-xxs items-center">
      <Label8 className="text-gray-350" as="p">
        {SOLEBOUND_LABEL}
      </Label8>
      <Tooltip className="inline-flex items-center relative z-1">
        <TooltipButton
          label={SOLEBOUND_TOOLTIP_LABEL}
          icon={
            <InfoCircle className="text-green-500 hover:fill-green-500 hover:text-black" />
          }
          size={IconSize.sm}
        />
        <TooltipPanel
          header={<Label4>{SOLEBOUND_LABEL}</Label4>}
          content={<Body8>{SOLEBOUND_COPY}</Body8>}
        />
      </Tooltip>
    </div>
  );
}
